import React from 'react';
import ReactDOM from "react-dom/client";
import './index.css';
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap-css-only/css/bootstrap.min.css";
import 'antd/dist/reset.css';
import { BrowserRouter } from "react-router-dom";
import reportWebVitals from './reportWebVitals';
import CoreApp from './CoreApp/CoreApp';
import './globalCss.css';
import './tableCss.css';
import ErrorBoundary from './Components/Pages/ErrorBound/ErrorBound';
import { AuthProvider } from "./Components/AuthContext/AuthContext";

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
	<BrowserRouter>
		<ErrorBoundary>
			<AuthProvider>
				<CoreApp />
			</AuthProvider>
		</ErrorBoundary>
	</BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
